import {getApiHost, getAuthCookie, getUserDetailsCookie} from "../Utils/apiUtils";

const qs = require('qs');
export const HEADERS = {
    ACCEPT : 'accept',
    CONTENT_TYPE : 'content-type',
    AUTHORIZATION :'Authorization',
    PRAGMA :'pragma',
    CACHE_CONTROL :'cache-control',
}

export const CONTENT_TYPE = {
    MULTIPART: 'multipart/form-data',
    JSON: 'application/json',
    URLENCODED: 'application/x-www-form-urlencoded'
}

const METHOD = {
    GET:'GET',
    POST:'POST',
    PUT:'PUT',
    PATCH:'PATCH',
    DELETE:'DELETE',
}

class GenericAPI {
    isBusy = false;
    apiHost = getApiHost();

    async get(endpoint, payload, auth){
        const params= qs.stringify(payload);
        return this.genericFetch(`${endpoint}?${params}`, METHOD.GET, null, {}, auth);
    }

    async post(endpoint, payload, contentType, auth){
        let headers = {}
        let requestBody;
        if(contentType === CONTENT_TYPE.JSON)  {
            requestBody = payload;
        } else if(contentType === CONTENT_TYPE.MULTIPART ) {
            requestBody = new FormData();
            for (const name in payload) {
                requestBody.append(name, payload[name]);
            }
        } else if(contentType === CONTENT_TYPE.URLENCODED) {
            requestBody = qs.stringify(payload);
        } else if (!contentType){
            const params= qs.stringify(payload);
            endpoint = `${endpoint}?${params}`;
        }

        if(contentType !== CONTENT_TYPE.MULTIPART ) {
            headers[HEADERS.CONTENT_TYPE] = contentType;
        }

        return this.genericFetch(endpoint, METHOD.POST, requestBody, headers, auth);
    }

    async put(endpoint, payload, contentType, auth){
        let headers = {}
        let requestBody;
        if(contentType === CONTENT_TYPE.JSON)  {
            requestBody = payload;
        } else if(contentType === CONTENT_TYPE.MULTIPART ) {
            requestBody = new FormData();
            for (const name in payload) {
                requestBody.append(name, payload[name]);
            }
        } else if(contentType === CONTENT_TYPE.URLENCODED) {
            requestBody = qs.stringify(payload);
        } else if (!contentType){
            const params= qs.stringify(payload);
            endpoint = `${endpoint}?${params}`;
        }

        if(contentType !== CONTENT_TYPE.MULTIPART) {
            headers[HEADERS.CONTENT_TYPE] = contentType;
        }
        return this.genericFetch(endpoint, METHOD.PUT, requestBody, headers, auth);
    }

    async patch(endpoint, payload, auth){
        return this.genericFetch(endpoint, METHOD.PATCH, payload, {}, auth);
    }

    async delete(endpoint, payload, auth){
        const params= qs.stringify(payload);
        return this.genericFetch(`${endpoint}?${params}`, METHOD.DELETE, payload, {}, auth);
    }

    async genericFetch(endpoint, method, payload, extraHeaders, auth) {
            const headers =  {
                [HEADERS.ACCEPT]: CONTENT_TYPE.JSON,
                // ensure API requests are not cached (similar headers exist in response)
                [HEADERS.CACHE_CONTROL]: 'no-store',
                [HEADERS.PRAGMA]: 'no-cache'
            }
            if(auth) {
                const auth = getAuthCookie();
                let { access_token } = auth;

                if(access_token === undefined){
                    const userCookieAuth = getUserDetailsCookie();
                    ({access_token} = userCookieAuth.token);
                }
                headers[HEADERS.AUTHORIZATION] = "Bearer "+ access_token;
            }
            Object.keys(extraHeaders).forEach((headerName) => {
                headers[headerName] = extraHeaders[headerName];
            });
            const body= payload;
            const options = {
                method,
                headers,
                body,
            }
        this.isBusy = true;
        const result = await fetch( this.apiHost + endpoint, options);
        const response = await this.parseResponse(result);
        this.isBusy = false;
        return response;
    }

    async parseResponse(apiResponse){
        try {
            const payload = JSON.parse(await apiResponse.text());
            return payload;
        } catch (error) {
            if (apiResponse.status === 204 || apiResponse.status === 202) {
                return {};
            }else {
                return { status: 500}
            }
        }
    }
}

export default GenericAPI;
